<template>
  <div id="navbar">

    <nav class="navbar navbar-light fixed-top border-bottom">
      <div class="navbar-brand">
        <router-link :to="{ name: 'Dashboard' }">
          <img src="/static/mark_blue_small.png" width="30" height="30" alt="Orbitist Logo">
        </router-link>
      </div>
      <form class="form-inline" v-if="currentUser != null">
        <router-link :to="{ name: 'Dashboard', params: {mode: 'settings'} }" class="btn btn-outline-primary"><i class="fal fa-user-circle"></i> {{ userProfile.name }}</router-link>
      </form>
    </nav>

  </div><!-- /#navbar -->
</template>

<script>
  import { mapState } from 'vuex'
  const fb = require('../firebaseConfig.js')

  export default {
    data() {
      return {
      }
    },
    computed: {
      ...mapState(['userProfile', 'currentUser'])
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/Navbar.vue